import { StreamChat } from 'stream-chat';

import type { TNetworkError } from '@/services/errors';

import { ERROR_CODES, errorUtils } from '@/services/errors';
import { STREAM_CHAT_API_KEY } from '@/constants/env';
import { logger } from '@/services/logger';

import { chatService } from './chatService';

const WHERE = 'streamClient.connect';

let client: StreamChat | null = null;

const isChatConfigured = (): boolean => STREAM_CHAT_API_KEY.length > 0;

const resolveStreamClient = (): StreamChat => {
  if (!client) {
    client = StreamChat.getInstance(STREAM_CHAT_API_KEY);
  }

  return client;
};

const connectStream = async (): Promise<StreamChat | TNetworkError> => {
  if (!isChatConfigured()) {
    return errorUtils.createNetworkError(ERROR_CODES.unknown, undefined, WHERE);
  }

  const credentials = await chatService.readCredentials();

  if (errorUtils.isNetworkError(credentials)) {
    return credentials;
  }

  const instance = resolveStreamClient();

  if (instance.userID === credentials.userID) {
    return instance;
  }

  try {
    await instance.connectUser({ id: credentials.userID }, credentials.token);

    return instance;
  } catch (error) {
    logger.error(WHERE, error);

    return errorUtils.createNetworkError(ERROR_CODES.unknown, undefined, WHERE);
  }
};

const disconnectStream = async (): Promise<void> => {
  if (!client || !client.userID) {
    return;
  }

  await client.disconnectUser();
};

export {
  connectStream,
  disconnectStream,
  isChatConfigured,
  resolveStreamClient,
};
